import { Type } from "@feathersjs/typebox";
export const TfmRerouteSchema = Type.Object({
    tmiId: Type.String(),
    protectedRouteSegment: Type.String(),
});
//# sourceMappingURL=tmi.js.map